import { render, staticRenderFns } from "./ModalSaveSucess.vue?vue&type=template&id=16362536&scoped=true&"
import script from "./ModalSaveSucess.vue?vue&type=script&lang=js&"
export * from "./ModalSaveSucess.vue?vue&type=script&lang=js&"
import style0 from "./ModalSaveSucess.vue?vue&type=style&index=0&id=16362536&prod&lang=css&"
import style1 from "./ModalSaveSucess.vue?vue&type=style&index=1&id=16362536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16362536",
  null
  
)

export default component.exports